import { makeStyles } from "@fluentui/react-components";
import React from "react";
import { $cloud90 } from "../../../../cssjs/colors";
import {
  ResourceAvailabilityColor,
  ResourceAvailabilityLabel,
  ResourceAvailabilityLegendLabel,
} from "../../../../enum/ResourceAvailabilityEnum";

const legendItems = [
  {
    color: ResourceAvailabilityColor[ResourceAvailabilityLabel.InUse],
    label: ResourceAvailabilityLegendLabel.InUse,
  },
  {
    color: ResourceAvailabilityColor[ResourceAvailabilityLabel.Available],
    label: ResourceAvailabilityLegendLabel.Available,
  },
  {
    color: ResourceAvailabilityColor[ResourceAvailabilityLabel.Inoperable],
    label: ResourceAvailabilityLegendLabel.Inoperable,
  },
  {
    color: ResourceAvailabilityColor[ResourceAvailabilityLabel.Unknown],
    label: ResourceAvailabilityLegendLabel.Unknown,
  },
];

const ResourceAvailabilityFooter = React.memo(
  function ResourceAvailabilityFooter() {
    const classes = useStyles();

    return (
      <footer
        className={classes.sharedLegend}
        data-testid="resource-availability-footer"
      >
        {legendItems.map((item) => (
          <div key={item.label} className={classes.legendItem}>
            <span
              className={classes.legendBox}
              style={{ backgroundColor: item.color }}
            />
            {item.label}
          </div>
        ))}
      </footer>
    );
  }
);

export default ResourceAvailabilityFooter;

const useStyles = makeStyles({
  sharedLegend: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    gap: "4px",
    marginTop: "auto",
    paddingTop: "12px",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "10px",
    minWidth: "0",
    flexShrink: 1,
    overflow: "hidden",
    whiteSpace: "nowrap",
    color: $cloud90,
  },
  legendBox: {
    width: "8px",
    height: "8px",
    borderRadius: "2px",
    flexShrink: 0,
  },
});
